import { render, staticRenderFns } from "./GoodsPurchase.vue?vue&type=template&id=5e103b0f"
import script from "./GoodsPurchase.vue?vue&type=script&lang=js"
export * from "./GoodsPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports